<template>
  <div class="app-popup-container">
    <transition name="opacity">
      <div v-if="show" class="app-popup-background" @click="close"></div>
    </transition>
    <transition name="bounce">
      <div v-if="show" class="app-popup" @click.self="close">
        <div class="app-popup-wrapper">
          <div class="close" @click="close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858Z"
                    fill="black" fill-opacity="0.65"/>
            </svg>
          </div>
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

  export default {
    name: "Popup",
    props: {
      show: {
        type: Boolean,
        required: true
      },
    },
    methods: {
      close(){
        this.$emit('closeEvent', null);
      }
    }
  }
</script>

<style scoped lang="scss">
  .bounce-enter-active {
    animation: bounce-in-popup .3s;
  }

  .bounce-leave-active {
    animation: bounce-in-popup .3s reverse;
  }

  @keyframes bounce-in-popup {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  .opacity-enter-active {
    animation: opacity-in-popup .3s;
  }

  .opacity-leave-active {
    animation: opacity-in-popup .3s reverse;
  }

  @keyframes opacity-in-popup {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
